module.exports = __webpack_public_path__ + "static/media/jugadores.4968e6ee.png";